import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components";
import {
  Login,
  Home,
  Blogs,
  BlogEdit,
  NotFound,
  Jobs,
  JobEdit,
  ViewApplicants,
  Employee,
  EmployeeEdit,
  LeaveApproval,
  LeaveRequest,
  LeaveRequestForm,
  HrWikipedia,
  UserProfile,
  HrBlogForm,
  BlogDetails,
  LeaveDetails,
  GoalsOrOKHours,
  GoalsEdit,
  GoalDetail,
  ContactUs,
  CaseStudies,
  CaseStudiesEdit,
} from "./pages";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./content/Layout";
import { usePersistData } from "./store";

function App() {
  const { user } = usePersistData();

  const isEmployeeL =
    user?.designation === "EMPLOYEE" && user?.managedEmployees?.length > 0;

  const isEmployee =
    user?.designation === "EMPLOYEE" &&
    (!user?.managedEmployees || user?.managedEmployees.length === 0);

  const isAdminOrHR =
    user?.designation === "ADMIN" || user?.designation === "HR";

  return (
    <Router>
      <div>
        <ToastContainer />
      </div>
      <Routes>
        {/* Login Route without Layout */}
        <Route path="/login" element={<Login />} />

        {/* Routes with Layout */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route
                  path="/"
                  element={<ProtectedRoute component={Blogs} />}
                />
                {isAdminOrHR && (
                  <>
                    <Route
                      path="/blog"
                      element={<ProtectedRoute component={Blogs} />}
                    />
                    <Route path="/blog/edit/:id" element={<BlogEdit />} />
                    <Route path="/job" element={<Jobs />} />
                    <Route path="/job/edit/:id" element={<JobEdit />} />
                    <Route
                      path="/job/applicants/:id"
                      element={<ViewApplicants />}
                    />
                    <Route path="/leave" element={<LeaveApproval />} />
                    <Route path="/employee" element={<Employee />} />
                    <Route
                      path="/employee/edit/:id"
                      element={<EmployeeEdit />}
                    />
                    <Route
                      path="/leaveRequest/:employeeId"
                      element={<LeaveDetails />}
                    />{" "}
                    <Route
                      path="/goalsOrOkHours"
                      element={<GoalsOrOKHours />}
                    />
                    <Route
                      path="/goalsOrOkHours/edit/:id"
                      element={<GoalsEdit />}
                    />
                    <Route path="/ContactedUser" element={<ContactUs />} />
                    <Route
                      path="/goalsDetails/:goalId"
                      element={<GoalDetail />}
                    />
                    <Route
                      path="/caseStudies"
                      element={<CaseStudies />}
                    />
                    <Route path="/caseStudies/edit/:id" element={<CaseStudiesEdit />} />


                  </>
                )}
                {isEmployeeL && (
                  <>
                    <Route path="/leave" element={<LeaveApproval />} />
                    <Route path="/employee" element={<Employee />} />
                    <Route
                      path="/employee/edit/:id"
                      element={<EmployeeEdit />}
                    />
                    <Route
                      path="/leaveRequest/:employeeId"
                      element={<LeaveDetails />}
                    />{" "}
                    <Route
                      path="/goalsOrOkHours"
                      element={<GoalsOrOKHours />}
                    />
                    <Route
                      path="/goalsOrOkHours/edit/:id"
                      element={<GoalsEdit />}
                    />
                    <Route path="/leaveRequest" element={<LeaveRequest />} />
                    <Route
                      path="/leaveRequest/form/:id"
                      element={<LeaveRequestForm />}
                    />
                    <Route
                      path="/goalsDetails/:goalId"
                      element={<GoalDetail />}
                    />
                  </>
                )}
                {isEmployee && (
                  <>
                    <Route path="/leaveRequest" element={<LeaveRequest />} />
                    <Route
                      path="/leaveRequest/form/:id"
                      element={<LeaveRequestForm />}
                    />
                    <Route
                      path="/goalsOrOkHours"
                      element={<GoalsOrOKHours />}
                    />
                    <Route
                      path="/goalsOrOkHours/edit/:id"
                      element={<GoalsEdit />}
                    />
                    <Route
                      path="/leaveRequest/:employeeId"
                      element={<LeaveDetails />}
                    />{" "}
                    <Route
                      path="/goalsDetails/:goalId"
                      element={<GoalDetail />}
                    />
                  </>
                )}
                <Route path="/wikkipedia" element={<HrWikipedia />} />
                <Route path="/wikkipedia/edit/:id" element={<HrBlogForm />} />
                <Route path="/wikipedia/:id" element={<BlogDetails />} />
                <Route path="/userProfile" element={<UserProfile />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;
